// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"f9b54371","287":"1d3962dc","740":"33c21017"}[chunkId] + ".chunk.js";
};